import * as React from "react"
import Seo from "../components/seo";
import Layout from "../components/layout/layout"
import ClientsTestimonial from "../components/clients-testimonial"
import Awards from "../components/awards"
import OurClients from "../components/our-clients"
import CaseStudy from "../components/case-study"
import BlogList from "../components/blog/blog-list"
import { Container, Row, Col, } from "react-bootstrap";
import { RetailMobilitySolutionsMeta } from "../data/metaData"
import { Link } from "gatsby";

export const Head = () => (
  <Seo
    title={RetailMobilitySolutionsMeta.metaTitle}
    description={RetailMobilitySolutionsMeta.metaDescription}
    ogImage={RetailMobilitySolutionsMeta.ogImage}
    twitterImage={RetailMobilitySolutionsMeta.twitterImage}
  />
)

const RetailMobilitySolutionsPage = () => {

  const firstsection = [
    {
      class: "segments-stores",
      title: "Department Stores",
      des: "We help department stores maximize customer service and profits and meet changing amid increased competition."
    },
    {
      class: "segments-discount",
      title: "Discount Stores",
      des: "We help optimize merchandizing, increase supply chain efficiencies, generate product mix forecast for better retention."
    },
    {
      class: "segments-grocers",
      title: "Grocers",
      des: "We help optimize prices, fine tune inventory planning, and deploy next generation POS systems to enhance the customer experience."
    },
    {
      class: "segments-retailers",
      title: "Specialty Retailers",
      des: "We help specialty retailers embrace the future of shopping by delivering concepts and solutions for instore selling."
    },
  ]

  const secsection = [
    {
      class: "retail-consulting-omnichannel",
      title: "Omnichannel",
      des: "Helping retailers to discover the apt path to omnichannel implementation for their product, based on their clienteles, competitors, and physical and digital assets."
    },
    {
      class: "retail-consulting-merchandising",
      title: "Merchandising",
      des: "Thorough preparation, augmented business operations, data mining and data analytics, while permitting flexibility to respond to market dynamics."
    },
    {
      class: "retail-consulting-retail",
      title: "Retail Stores",
      des: "Leveraging on retail knowhow, empower with new workforce and task management solutions, and streamline your PoS, raise operational efficiency."
    },
    {
      class: "retail-consulting-chain",
      title: "Supply Chain",
      des: "Resolve multifaceted supply chain issues, bringing value and reserves along their conversion journey e-retailers need to renovate their supply chains to be quicker and more agile."
    },
    {
      class: "retail-consulting-enterprise",
      title: "Retail Enterprise Services",
      des: "Combining deep retail and program management expertise with top practices to ensure you get the highest quality solution in the most lucrative manner."
    },
    {
      class: "retail-consulting-commerce",
      title: "m-commerce",
      des: "Using the modern mobility and various technologies, ecommerce solutions are moving to portable gadgets we don’t dare stepping out without."
    },
  ]

  return (

    <>
      <Layout>
        <section className="section  background-pattern">
          <Container className="py-5 mt-lg-5">
            <div className="banner-content py-lg-4 max-width-950">
              <h1 className="mb-4">
                <span className="text-primary">Retail app</span> development company
              </h1>
              <p className="lead mb-0">
                From understanding clients to offering a unified experience across channels, retail giants rely on us to work better and work differently whether it’s fulfilling shopper’s expectations or revamping the supply chain.
              </p>
              <Link to="/request-quote.html" className="btn btn-lg btn-primary-theme-outline mt-4 mt-lg-5">
                Get a free quote
              </Link>
            </div>
          </Container>
        </section>
        <section className="section ">
          <Container className="py-5">
            <div className="mb-5 pb-1">
              <h2 className="mb-4">
                <span className="text-primary">Segments</span> of retails that we <br />provide solution for
              </h2>
              <p className="max-width-950 lead">While retail as an industry is huge and comprised of endless number of sectors. These are some of the segments we have provided solution to with success.</p>
            </div>
            <Row className="g-4" xs={1} md={2} lg={3} xl={4}>
              {
                firstsection.map((item, index) => (
                  <Col key={index}>
                    <div className="dark-box-1 center-icon-box text-center equal-height">
                      <i className={`retail-mobility-sprite ${item.class} icon-size-70 mb-4`}></i>
                      <h3 className="text-center h4 mb-3">{item.title}</h3>
                      <p className="mb-0">{item.des}</p>
                    </div>
                  </Col>
                ))
              }
            </Row>
          </Container>
        </section>
        <section className="section bg-light">
          <Container className="py-5">
            <div className="mb-5 pb-1">
              <h2 className="mb-4">
                Retail <span className="text-primary">Consulting</span> & Solutions
              </h2>
              <p className="max-width-950 lead">Peerbit’s retail practice helps retailers turn today’s pain points into new business opportunities, and optimize their retail operation with the combination of traditional and modern sales art.</p>
            </div>
            <Row className="g-4" xs={1} md={2} lg={3}>
              {
                secsection.map((item, index) => (
                  <Col key={index}>
                    <div className="dark-box-2 center-icon-box text-center equal-height">
                      <i className={`retail-mobility-sprite ${item.class} icon-size-70 mb-4`}></i>
                      <h3 className="text-center h4 mb-3">{item.title}</h3>
                      <p className="mb-0">{item.des}</p>
                    </div>
                  </Col>
                ))
              }
            </Row>
          </Container>
        </section>
        <section className="section ">
          <Container className="py-5">
            <div className="mb-5 pb-1">
              <h2 className="mb-4">
                <span className="text-primary">Technology</span> that are <br />defining the future of retail
              </h2>
              <p className="max-width-950 lead">Retail sector is undergoing a pool of changes. There is more to technology, cloud and mobility to it than retail stores and PoS solutions.</p>
            </div>
            <Row className="g-4" xs={1} md={2} lg={3}>
              <Col>
                <div className="dark-box-1 center-icon-box text-center equal-height">
                  <h3 className="text-center h4 mb-3">Contactless payment</h3>
                  <p className="mb-0">Usage of radio-frequency identification (RFID) or near field communication (NFC, e.g. Samsung Pay, Apple Pay, Google Pay) are on rise</p>
                </div>
              </Col>
              <Col>
                <div className="dark-box-1 center-icon-box text-center equal-height">
                  <h3 className="text-center h4 mb-3">Artificial Intelligence</h3>
                  <p className="mb-0">Artificial intelligence in retail is being applied in new ways across the entire product and service cycle—from assembly to post-sale customer service interactions</p>
                </div>
              </Col>
              <Col>
                <div className="dark-box-1 center-icon-box text-center equal-height">
                  <h3 className="text-center h4 mb-3">Augmented Reality</h3>
                  <p className="mb-0">Retailers are riding the fast approaching wave of augmented reality to bring additional capabilities in their physical and digital experiences.</p>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
        <ClientsTestimonial />
        <Awards />
        <OurClients />
        <CaseStudy />
        <BlogList />
      </Layout>
    </>
  )
}

export default RetailMobilitySolutionsPage
